import { useEffect } from 'react';

import { useUserAccount } from '../../configuration/login/loginSlice';
import { useAppDispatch, useAppSelector } from '../../configuration/setup/hooks';
import {
    fleetGroupFilterAccountChanged,
    fleetGroupFilterSelectionLoaded,
    getFleetGroupFilterAccountId,
    getSelectedFleetGroupTagIds,
} from './fleetGroupFilterSlice';

const storageKey = (accountId: string) => `chat.fleetGroupFilter.${accountId}`;

const loadSelectedTagIds = (accountId: string): string[] => {
    try {
        const value = window.localStorage.getItem(storageKey(accountId));
        const parsed = value ? JSON.parse(value) : [];
        return Array.isArray(parsed) ? parsed.filter((item): item is string => typeof item === 'string') : [];
    } catch (_) {
        return [];
    }
};

const saveSelectedTagIds = (accountId: string, selectedTagIds: string[]) => {
    try {
        window.localStorage.setItem(storageKey(accountId), JSON.stringify(selectedTagIds));
    } catch (_) {
        // Intentionally left blank
    }
};

export const useFleetGroupFilterPersistence = () => {
    const dispatch = useAppDispatch();
    const userAccountId = useUserAccount();
    const filterAccountId = useAppSelector(getFleetGroupFilterAccountId);
    const selectedTagIds = useAppSelector(getSelectedFleetGroupTagIds);

    useEffect(() => {
        dispatch(fleetGroupFilterAccountChanged(userAccountId));
        dispatch(fleetGroupFilterSelectionLoaded(userAccountId ? loadSelectedTagIds(userAccountId) : []));
    }, [dispatch, userAccountId]);

    useEffect(() => {
        if (filterAccountId) {
            saveSelectedTagIds(filterAccountId, selectedTagIds);
        }
    }, [filterAccountId, selectedTagIds]);
};
